import React from 'react';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css';
import LargeDetailBox from '../../common/DetailBox/LargeDetailBox';
import SmallDetailBox from '../../common/DetailBox/SmallDetailBox';
import LargeDetailTextBox from '../../common/DetailBox/LargeDetailTextBox';
import FeaturesListDetail from '../../common/FeaturesListAdd/FeaturesList';
import './DetailPopup.css';

// const DetailPopup = ({ isOpen, title, details, onClose }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="popup-overlay">
//       <div className="popup popup1">
//         <CloseButton onClick={onClose} />
//         <div className="popup-name-button">
//           <h2 className="popup-name">{title}</h2>
//         </div>
//         <div className="edit-second-input-box-container">
//           {details.map((detail, index) => (
//             <div key={index} className='input-box-container'>
//               <label className='input-label has-value'>{detail.label}</label>
//               <input
//                 type="text"
//                 className='input-box detail-box'
//                 value={detail.value}
//                 readOnly
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DetailPopup;

// const DetailPopup = ({ isOpen, title, details, onClose }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="popup-overlay">
//       <div className="popup popup1">
//         <CloseButton onClick={onClose} />
//         <div className="popup-name-button">
//           <h2 className="popup-name">{title}</h2>
//         </div>
//         <div className="edit-second-input-box-container detail-popup-container">
//           {details.map((detail, index) => {
//             if (detail.type === 'large') {
//               return <LargeDetailBox key={index} label={detail.label} value={detail.value} />;
//             } else if (detail.type === 'small') {
//               return <SmallDetailBox key={index} label={detail.label} value={detail.value} />;
//             } else if (detail.type === 'textarea') {
//               return <LargeDetailTextBox key={index} label={detail.label} value={detail.value} />;
//             } else {
//               return (
//                 <div key={index} className="input-box-container">
//                   <label className="input-label has-value">{detail.label}</label>
//                   <input
//                     type="text"
//                     className="input-box detail-box"
//                     value={detail.value}
//                     readOnly
//                   />
//                 </div>
//               );
//             }
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DetailPopup;
const DetailPopup = ({ isOpen, title, details, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      {/* <div className="scroll-class"> */}
      <div className="popup popup1">
        <CloseButton onClick={onClose} />
        <div className="popup-name-button">
          <h2 className="popup-name">{title}</h2>
        </div>
        <div className="edit-second-input-box-container detail-popup-container">
          {details.map((detail, index) => {
            switch (detail.type) {
              case 'large':
                return (
                  <LargeDetailBox
                    key={index}
                    label={detail.label}
                    value={detail.value}
                  />
                );
              case 'small':
                return (
                  <SmallDetailBox
                    key={index}
                    label={detail.label}
                    value={detail.value}
                  />
                );
              case 'features-list':
                return (
                  <FeaturesListDetail
                    key={index}
                    title={detail.label}
                    planFeatures={detail.value}
                  />
                );
              default:
                return (
                  <div key={index} className="input-box-container">
                    <label className="input-label has-value">{detail.label}</label>
                    <input
                      type="text"
                      className="input-box detail-box"
                      value={detail.value}
                      readOnly
                    />
                  </div>
                );
            }
          })}
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};
export default DetailPopup;